import { render, staticRenderFns } from "./server-income-channel-list.vue?vue&type=template&id=16865df5&scoped=true&"
import script from "./server-income-channel-list.vue?vue&type=script&lang=js&"
export * from "./server-income-channel-list.vue?vue&type=script&lang=js&"
import style0 from "./server-income-channel-list.vue?vue&type=style&index=0&id=16865df5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16865df5",
  null
  
)

export default component.exports